import React from 'react';
import bem from 'utils/bem';
import { observer } from 'mobx-react-lite';
import { useMobile } from 'utils/media';
import { Dialog } from '@mui/material';
import Icon from 'components/Icon';
import CourseForm from '../index';
import Model from '../../../../../model';

import './index.sass';

const { block, el } = bem('course-form-modal');

const CourseFormModal = () => {

    const { closeCourseForm, isCourseFormOpen, courseDigitalId, coursePrice, courseTitle } = Model.modal;
    const { isMobile } = useMobile();

    const handleClose = () => {
        closeCourseForm();
    }

    return (
        <Dialog
            className={ block() }
            open={ isCourseFormOpen }
            onClose={ handleClose }
            fullWidth={ true }
            fullScreen={ isMobile }
            maxWidth={ 'md' }
            scroll={ 'body' }
            PaperProps={ {
                sx: {
                    maxWidth: 800,
                    margin: '0 auto',
                    width: 800,
                    borderRadius: isMobile ? 0 : '20px'
                }
            } }
        >
            <div className={ el('content') }>
                <div className={ el('form') }>
                    <CourseForm price={coursePrice} digitalId={courseDigitalId} title={courseTitle}/>
                </div>
                <div className={el('header')}>
                    <div className={el('close')} onClick={handleClose}><Icon name={'x'}/></div>
                </div>
            </div>
        </Dialog>
    )
}

export default observer(CourseFormModal);
